import { useState } from 'react';
import { X } from 'lucide-react';
import { useCart } from '@/context/CartContext';

export default function QuickBuy({ product, onClose }) {
  const { addItem, loading } = useCart();
  const [selectedOptions, setSelectedOptions] = useState({});
  const [error, setError] = useState('');

  const handleAdd = async () => {
    const requiredOptions = product.options || [];
    for (const opt of requiredOptions) {
      if (!selectedOptions[opt.name]) {
        setError(`Please select a ${opt.name}`);
        return;
      }
    }
    setError('');
    await addItem(product.id, 1, Object.keys(selectedOptions).length > 0 ? selectedOptions : null);
    onClose();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-4"
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-black/40" />
      <div
        className="relative bg-white w-full max-w-sm z-10"
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-start justify-between p-5 border-b border-gray-100">
          <div>
            <p className="text-xs uppercase tracking-widest text-gray-400 mb-0.5">Quick Buy</p>
            <h3 className="font-bebas text-xl tracking-tight uppercase leading-none">{product.name}</h3>
            <p className="text-sm mt-1">
              {product.sale_price ? (
                <>
                  ${Number(product.sale_price).toFixed(2)}
                  <span className="ml-2 text-gray-400 line-through text-xs">${Number(product.price || 0).toFixed(2)}</span>
                </>
              ) : (
                <>${Number(product.price || 0).toFixed(2)}</>
              )}
            </p>
          </div>
          <button onClick={onClose} className="p-1 text-gray-400 hover:text-black transition-colors">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Options */}
        <div className="p-5 space-y-4">
          {(product.options || []).map(option => (
            <div key={option.id || option.name}>
              <p className="text-xs uppercase tracking-widest font-bold mb-2">{option.name}</p>
              <div className="flex flex-wrap gap-2">
                {(option.values || []).map(value => (
                  <button
                    key={value.id || value.name}
                    onClick={() => { setSelectedOptions(prev => ({ ...prev, [option.name]: value.name })); setError(''); }}
                    className={`px-3 py-1.5 text-xs uppercase tracking-wide border transition-colors ${
                      selectedOptions[option.name] === value.name
                        ? 'bg-black text-white border-black'
                        : 'border-gray-300 hover:border-black'
                    }`}
                  >
                    {value.name}
                  </button>
                ))}
              </div>
            </div>
          ))}

          {error && <p className="text-xs text-red-500 uppercase tracking-wide">{error}</p>}

          <button
            onClick={handleAdd}
            disabled={loading}
            className="w-full bg-black text-white py-3 text-xs uppercase tracking-[0.15em] font-bold hover:bg-gray-800 transition-colors disabled:opacity-50"
          >
            {loading ? 'Adding...' : 'Add to Cart'}
          </button>
        </div>
      </div>
    </div>
  );
}
